import type { paths } from '@orlikfy/api-interfaces';

// POST /users/referral
export const POST_USER_REFERRAL_PATH = '/users/referral' as const satisfies keyof paths;
type PostUserReferralOperation = paths[typeof POST_USER_REFERRAL_PATH]['post'];
export type PostUserReferralBody = PostUserReferralOperation['requestBody']['content']['application/json'];
